export default [
  {
    path: "/parceiros",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "parceiros_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [{ label: "parceiros", to: "parceiros_list" }],
          permission: "parceiro:view",
          title: "Parceiros",
        },
      },
      {
        name: "parceiros_create",
        path: "novo",
        component: () => import("./pages/Create"),
        meta: {
          breadcrumbs: [{ label: "parceiros", to: "parceiros_list" }],
          permission: "parceiro:create",
          title: "Parceiros - Cadastro",
        },
      },
      {
        name: "parceiros_edit",
        path: "editar/:id",
        component: () => import("./pages/Edit"),
        meta: {
          breadcrumbs: [{ label: "parceiros", to: "parceiros_list" }],
          permission: "parceiro:edit",
          title: "Parceiros - Edição",
        },
      },
    ],
  },
];
